export { fitTextFontSize } from "./fitTextFontSize.js";
export type { FitTextOptions, FitTextResult } from "./fitTextFontSize.js";
